import ModelAddToForm from "./model-add-to-form";

const Forms = {
  ModelAddToForm,
};

export default Forms;
